export const ResponseScreenEnums = Object.freeze({
  STATUS_COMPLETED: "completed",
  STATUS_FAILED: "failed",
  STATUS_PENDING: "pending",
  STATUS_QUEUED: "queued",
  STATUS_ACTIVE: "Active",
  STATUS_CLOSED: "Closed",
  STATUS_DRAFT: "Draft",
  STATUS_ACCEPTED: "Accepted",
  STATUS_REJECTED: "Rejected",
  STATUS_ALL: "All",
  STATUS_SELF: "Self",
  STATUS_VENDOR: "Vendor",
  EVALUATION_TYPE_SMARTAI_ALL: "smartAi_all",
  EVALUATION_TYPE_CORRECTNESS_VISUAL: "smart_correctness_visual",
  EVALUATION_TYPE_CORRECTNESS_AUDIO: "smart_correctness_audio",
  EVALUATION_TYPE_CORRECTNESS: "smart_correctness",
  QUESTION_TYPE_VIDEO: "Video",
  QUESTION_TYPE_MCQ: "MCQ",
  QUESTION_TYPE_ESSAY: "Essay",
  QUESTION_TYPE_CODING: "Coding",
  TESTCASE_PASS: "pass",
  STATUS_NUMBER: "number",
});
